export function checkIfStringStartsWith(str,substrs){return substrs.some(function(substr){return str.toLowerCase().startsWith(substr.toLowerCase());});}